import React from "react";

import background from "../../assets/img/login-background.png";
import styles from "./AuthPage.module.scss";

export const AuthPage: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <div
      className={styles.login}
      style={{ backgroundImage: `url(${background})` }}
    >
      {children}
    </div>
  );
};
